export function getDomain(url){
    try {
      const { hostname } = new URL(url)
      return hostname.replace(/^www\./, "")
    } catch (error) {
      console.error("Invalid URL:", error)
      return url
    }
}